export default __webpack_public_path__ + "static/media/jiezhifa_2.c9606a9d.png";